import { useNavigate } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { cn } from "@/lib/utils";

export const StatCard = ({ icon: Icon, label, value, sub, tone = "green", testid, to }) => {
  const nav = useNavigate();
  const tones = {
    green: "bg-[#001A3B] text-[#F5F7FA]",
    sage: "bg-[#12386B] text-white",
    gold: "bg-[#A5894E] text-[#3a2f08]",
    slate: "bg-[#334155] text-white",
    red: "bg-red-600 text-white",
    amber: "bg-amber-500 text-white",
  };
  const Tag = to ? "button" : "div";
  return (
    <Tag
      type={to ? "button" : undefined}
      onClick={to ? () => nav(to) : undefined}
      className={cn(
        "group w-full rounded-2xl border border-[#E2E8F0] bg-white p-5 text-left transition-[transform,box-shadow,border-color] duration-300 hover:-translate-y-0.5 hover:shadow-[0_8px_30px_rgba(0,26,59,0.08)]",
        to && "cursor-pointer hover:border-[#A5894E]/60 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#A5894E]"
      )}
      data-testid={testid}
    >
      <div className="flex items-start justify-between">
        <div className={cn("flex h-11 w-11 items-center justify-center rounded-xl", tones[tone])}>
          <Icon className="h-5 w-5" />
        </div>
        {to && <ArrowUpRight className="h-4 w-4 text-[#8695AB] opacity-0 transition-opacity group-hover:opacity-100" />}
      </div>
      <div className="mt-4">
        <div className="font-heading text-2xl font-bold tracking-tight text-[#18221F]">{value}</div>
        <div className="mt-0.5 text-sm font-medium text-[#4A5568]">{label}</div>
        {sub && <div className="mt-1 text-xs text-[#8695AB]">{sub}</div>}
      </div>
    </Tag>
  );
};
